/* import __COLOCATED_TEMPLATE__ from './identity-verification-key-display.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';
import type MessengerApiSecret from 'embercom/models/messenger-security/messenger-api-secret';
interface Args {
  keys: MessengerApiSecret[];
}

export default class IdentityVerificationKeyDisplay extends Component<Args> {
  @service declare router: RouterService;
  @service declare appService: any;

  get activeKeys() {
    return this.args.keys.sortBy('createdAt').reverse();
  }

  @action
  navigateToKeyManagement() {
    let params = this.appService.app.canUseFeature('new-security-settings-ui')
      ? { tab: 'messenger-security' }
      : { section: 'messenger-security' };
    this.router.transitionTo('apps.app.settings.workspace.security', {
      queryParams: params,
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'MessengerSettings::Security::IdentityVerificationKeyDisplay': typeof IdentityVerificationKeyDisplay;
    'messenger-settings/security/identity-verification-key-display': typeof IdentityVerificationKeyDisplay;
  }
}
